import { useRef } from 'react';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PreviewSharpIcon from '@mui/icons-material/PreviewSharp';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { SelectMenuV2 } from '../../../components/common/v2/SelectMenuV2/SelectMenuV2';

export const ROW_ACTIONS = {
  Edit: 'edit',
  Delete: 'delete',
  View: 'view',
};

const options = [
  {
    label: (
      <Box display="flex" alignItems="center" gap={1}>
        <PreviewSharpIcon color="primary" />
        Preview
      </Box>
    ),
    value: ROW_ACTIONS.View,
  },
  {
    label: (
      <Box display="flex" alignItems="center" gap={1}>
        <EditIcon color="primary" />
        Edit
      </Box>
    ),
    value: ROW_ACTIONS.Edit,
  },
  {
    label: (
      <Box display="flex" alignItems="center" gap={1}>
        <DeleteOutlinedIcon color="primary" />
        Delete
      </Box>
    ),
    value: ROW_ACTIONS.Delete,
  },
];

export const RowMenuV2 = ({ selectedAction, setSelectedAction }) => {
  const wrapperRef = useRef(null);

  return (
    <Wrapper ref={wrapperRef}>
      <SelectMenuV2
        ref={wrapperRef}
        options={options}
        menuLabel="Row Action"
        selected={selectedAction}
        onChange={setSelectedAction}
        popoverPositionX="right"
        customHead={
          <Box display="flex" alignItems="end">
            <MoreVertIcon />
          </Box>
        }
      />
    </Wrapper>
  );
};

const Wrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));
